import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { orderInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getOrderInfo } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "status",
  "order_id",
  "order_status",
  "order_type",
  "order_status_message",
  "order_date",
  "created_at",
  "last_updated",
];

const TmobilejOrderInfoBatch = () => (
  <BatchDetail
    title="Order Info"
    apiGet={__getOrderInfo}
    client={CLIENTS.tmobilej}
    columnsFactory={orderInfoColumns}
    copyKeys={COPY_KEYS}
    getRowPath={(row) => `/tmobilej/order_info/${row.id}`}
    disableLatestOnly
  />
);

export default TmobilejOrderInfoBatch;
